/// <reference path="../../app.definition.ts" />

import { APIs } from "@common/model/apis";
import { Plan } from "@common/model/plan";
import angular from "angular";
import { Util } from "@common/util";
import { TeamRole } from "@common/model/teamrole";
import _ from "lodash";
import { PostTypeEnums } from "@common/model/_adocument";
import { SelectOption } from "@common/model/analytics.model";
import { CachedDocument } from "@common/model/cachedDocument";
import { UserList } from "@common/model/cachingList";
import { CareDetail } from "@common/model/careDetail";
import { CrProfile } from "@common/model/crProfile";
import { Discussion } from "@common/model/discussion";
import { DiscussionComment } from "@common/model/discussionComment";
import { Document } from "@common/model/_adocument";
import { DocumentFolder } from "@common/model/documentFolder";
import { InviteInfo } from "@common/model/inviteInfo";
import { Permission } from "@common/model/permission";
import { ProjectType } from "@common/model/projectType";
import { SearchResult } from "@common/model/searchResult";
import { Service } from "@common/model/Service";
import { ServiceNote } from "@common/model/serviceNote";
import { ShareableLink } from "@common/model/shareableLink";
import { SignUpResponse } from "@common/model/signUpResponse";
import { Subject, StudentGrade, SubjectPayload } from "@common/model/subject";
import { SubjectImage } from "@common/model/subjectImage";
import { ErrorTransaction } from "@common/model/transaction";
import { User } from "@common/model/user";
import { UserExperience } from "@common/model/userExperience";
import { UserIntegrations } from "@common/model/userIntegrations";
import { ValidationPolicy } from "@common/model/validationPolicy";
import { PolicyTypeEnum } from "@common/service/validation.service";
import {NULL_TEXT} from "@common/model/constants";
import {Notification} from "@common/model/notification";
import { CacheService } from "@common/service/cache.service";

export class JavaApiAdapterService {
    static $inject = ["$q", "APIService", "$http", "CacheService"];
    apigClient;
    $q;
    $http;
    $_cache: CacheService;
    errorCallback: any;
    credentials: any;
    temp: any;
    contextCallback: any;
    promises: any;
    reportError;
    api;

    constructor(
        $q,
        APIService,
        $http,
        CacheService: CacheService
    ) {
        this.api = APIService;
        this.$q = $q;
        this.$http = $http;
        this.$_cache = CacheService;
        this.credentials = {};

        this.reportError = (message) => {
            console.log('I came to report this: ', message);
            let deferred = $q.defer();
            try {
                let body = {};
                body['message'] = btoa(JSON.stringify(message));
                //Util.objectEscape(body);
                if (!!this.apigClient) {
                    if (!!this.apigClient['apiExceptionMessagePost']) {
                        this.apigClient['apiExceptionMessagePost']({}, body)
                            .then((success: any) => {
                                console.log('logged', body);
                                Util.objectUnEscape(success.data);
                                deferred.resolve();
                            })
                            .catch(() => {
                                deferred.resolve();
                            });
                    }
                } else {
                    if (!!this.errorCallback)
                        this.errorCallback('Please login to access the ecare system');
                    deferred.reject(('Api not instantiated' + ' - ' + 'apiExceptionMessage'));
                }
            } catch (e) {
                console.log(e, message);
                return;
            }

            return deferred.promise;
        }
    }

    init(errorCallback?) {
        this.errorCallback = errorCallback;
    }

    updateTeamRole(roleName, subjectId, teamRoleId) {


        const body = {
            'roleName': roleName,
            'subjectId': subjectId,
        };

        return this.api.patch(APIs.UPDATE_TEAM_ROLE.interpolate({ teamRoleId }), body).then(data => {
            let teamMems = [];
            for (let i = 0; !!data && i < data.length; i++) {
                teamMems.push(new TeamRole().deserialize(data[i]));
            }
            teamMems = teamMems.sort(
                (a, b) => {
                    return (!!a.roleName) ? a.roleName.toLowerCase().localeCompare(b.roleName.toLowerCase()) : b.roleName;
                }
            );
            return teamMems;
        });
    }

    addTeamRole(roleName, subjectTypeId) {

        const body = {
            'roleName': roleName,
            'subjectTypeId': subjectTypeId
        };

        return this.api.post(APIs.ADD_TEAM_ROLE, body).then(data => {
            let teamMems = [];
            for (let i = 0; !!data && i < data.length; i++) {
                if (!!data[i].roleName && data[i].roleName.length > 0) {
                    teamMems.push(new TeamRole().deserialize(data[i]));
                }
            }
            teamMems = teamMems.sort(
                (a, b) => {
                    return (!!a.roleName) ? a.roleName.toLowerCase().localeCompare(b.roleName.toLowerCase()) : b.roleName;
                }
            );
            return teamMems;
        });
    }

    // Add Project type api call
    addProjectType(projectType) {

        const body = {
            'projectType': projectType
        };

        return this.api.post(APIs.ADD_TEAM_ROLE, body).then(data => {
            let teamMems = [];
            for (let i = 0; !!data && i < data.length; i++) {
                teamMems.push(new ProjectType().deserialize(data[i]));
            }
            teamMems = teamMems.sort(
                (a, b) => {
                    return (!!a.projectType) ? a.projectType.toLowerCase().localeCompare(b.projectType.toLowerCase()) : b.projectType;
                }
            );
            return teamMems;
        });
    }

    getUserByEmail(email, subjectId) {

        const queryParams = {
            "subjectId": subjectId,
            "providerIdentity": email
        };

        return this.api.get(APIs.ADD_USER_BY_EMAIL, queryParams).then(data => {
            return new User().deserialize(data);
        })

    }

    logOut() {
        return this.api.get(APIs.LOGOUT).then(() => {
            return;
        })
    }

    logDetailToBackend(logDetail) {
        let body = {
            "documentId": logDetail.documentId,
            "startTime": logDetail.startTime,
            "endTime": logDetail.endTime,
            "success": logDetail.success,
            "eventName": logDetail.eventName,
            "combinePdfRequestId": logDetail.combinePdfRequestId,
            "additionalProperties": logDetail.additionalProperties
        };

        return this.api.post(APIs.LOG_DETAILS_TO_BACKEND, body).then(() => {
            return true;
        })
    }

    getCountries() {
        return this.api.get(APIs.GET_COUNTRIES).then(data => {
            return data;
        })
    }

    getComments(documentId : number | string, password : string, fetchSystemComments? : boolean) {
        let loadSystemMessage : boolean;
        loadSystemMessage = !!fetchSystemComments;

        let queryParams = {
            "fetchSystemComments": loadSystemMessage
        }

        let body = {
            "password": password,
        };

        return this.api.post(APIs.GET_COMMENTS.interpolate({ documentId }), body, queryParams).then(data => {
            let discussionComments = [];
            for (let i = 0; !!data && i < data.length; i++) {
                // Keep deleted comments (their text may be withheld) so the
                // "This comment was deleted" placeholder still renders on reload.
                if (!!data[i].comment || !!data[i].deleted)
                    discussionComments.push(new DiscussionComment().deserialize(data[i]));
            }

            return (discussionComments);
        });
    }

    getInvitationInfo(token) {
        return this.api.post(APIs.GET_INVITATION_INFO.interpolate({ token }), { token }).then(data => {
            console.log("Got invitation: ", data);
            return new InviteInfo().deserialize(data);
        });
    }

    getIdentity() {
        return this.api.get(APIs.GET_IDENTITY).then((user) => new User().deserialize(user));
    }

    saveNotificationSettings(notificationSettings) {
        const body = {
            'isDisabled': notificationSettings.isNotificationDisabled
        }
        return this.api.patch(APIs.SAVE_NOTIFICATION_SETTINGS, body).then(data => {
            return data;
        })
    }

    getNotificationPreferences() {
        return this.api.get(APIs.GET_NOTIFICATION_PRERENCES).then(data => {
            return data;
        });
    }

    saveNotificationPreferences(preferences) {
        return this.api.put(APIs.UPDATE_NOTIFICATION_PREFERENCES, preferences).then(data => {
            return data;
        });
    }


    //fetch all the Team Members for selected subject
    getTeamMembersForSubject(isActive, subjectId) {

        const queryParams = {
            "isActive": isActive,
            "subjectId": subjectId
        }

        return this.api.get(APIs.GET_TMS_FOR_TEAM, queryParams).then(data => {
            let subjectList = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let subject = new Subject().deserialize(data[i]);
                    if (subject) {
                        subjectList.push(subject);
                    }
                }
            }
            return subjectList;
        });
    }

    //Get pending join team actions for logged-in user
    getPendingInvitations() {

        return this.api.get(APIs.GET_PENDING_INVITATION).then(data => {
            let pendingInvitations = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let subject = new Subject().deserialize(data[i]);
                    if (subject) {
                        pendingInvitations.push(subject);
                    }
                }
            }
            return pendingInvitations;
        });
    }

    getTeamMembers(subjectId, documentId?, postType?) {
        let queryParams = {}
        if (!!documentId) {
            queryParams = {
                documentId,
            };
        }
        if (!!postType) {
            queryParams['postType'] = postType;
        }

        return this.api.get(APIs.GET_TEAM_MEMBERS.interpolate({ subjectId }), queryParams).then(data => {
            let providers = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempProvider = new User().deserialize(data[i]);
                    if (!!tempProvider)
                        providers.push(tempProvider);
                }
            }
            return providers;
        });
    }

    getSubjectsTeamMembers(subjectIds) {
        let body = {
            "ids": subjectIds
        }

        return this.api.post(APIs.GET_SUBJECTS_TMS, body).then(data => {
            return data;
        });
    }

    updateTeamMember(paramUser, subjectId, password, saveInvite?) {
        let body = JSON.parse(JSON.stringify(paramUser));
        body.subjectId = subjectId;
        body.password = password;

        if (!!body.photo && body.photo.indexOf(',') != -1) {
            body.photo = body.photo.split(',')[1];
            body.photoMimeType = 'image/png'
        } else {
            delete body.photoMimeType;
        }

        delete body.roles;
        delete body.policies;
        delete body.cPassword;
        delete body.fullName;
        delete body.preferredEmail;

        if (saveInvite) {
            body.saveAndInvite = saveInvite;
        }

        return this.api.patch(APIs.UPDATE_TEAM_MEMBER, body).then(data => {
            return new User().deserialize(data);
        });
    }

    createInactiveTeamMember(paramUser, subjectId) {
        let body = JSON.parse(JSON.stringify(paramUser));
        body.subjectId = subjectId;

        if (!!body.photo && body.photo.indexOf(',') != -1) {
            body.photo = body.photo.split(',')[1];
        }

        if (!!body.photo) body.photoMimeType = 'image/png';

        delete body.roles;
        delete body.policies;
        delete body.cPassword;
        delete body.preferredEmail;

        return this.api.post(APIs.CREATE_INACTIVE_TM, body).then(data => {
            return new User().deserialize(data);
        });
    }

    createUser(paramUser, token?) {
        let body = JSON.parse(JSON.stringify(paramUser));
        //  body.recoveryAnswer = 'Boston';
        //  body.recoveryQuestionId = 1;

        if (!!body.photo && body.photo.indexOf(',') != -1) {
            body.photo = body.photo.split(',')[1];
            body.photoMimeType = 'image/png'
        } else {
            if (!!body.photo) {
                delete body.photo
            }
            delete body.photoMimeType;
        }
        if (!!token) {
            body.token = token;
            //body.code = code;
        } else {
            delete body.token;
            delete body.code;
        }

        delete body.roles;
        delete body.policies;
        delete body.cPassword;
        delete body.preferredEmail;

        //  body.password = password;

        return this.api.post(APIs.SIGNUP, body).then(data => {
            return new SignUpResponse().deserialize(data);
        });
    }

    updateUser(paramUser) {

        let body = JSON.parse(JSON.stringify(paramUser));
        body.userId = body.id;
        // console.log(body);

        let params = {
            "userId": body.userId
        }

        if (!!body.photo && body.photo.indexOf(',') != -1)
            body.photo = body.photo.split(',')[1];
        // temp until server team fixes

        return this.api.patch(APIs.UPDATE_USER.interpolate(params), body).then(data => {
            return (new User().deserialize(data));
        });
    }


    changePassword(userId, newPassword, oldPassword?) {
        let deferred = this.$q.defer();
        let body = {
            userId: userId,
            password: newPassword
        };

        if (!!oldPassword) {
            body['oldPassword'] = oldPassword;
        }

        this.api.put(APIs.CHANGE_PASSWORD, body).then(data => {
            deferred.resolve(data);
        },
            (e => {
                console.log('error while changing password');
                deferred.reject(e);
            }));
        return deferred.promise;
    }

    getUserPermissions() {
        let deferred = this.$q.defer();

        this.api.get(APIs.GET_PERMISSIONS_FOR_USER).then(data => {
            let perm = {};
            Object.keys(data).forEach((k) => {
                perm[k] = [];
                data[k].forEach(p => {
                    perm[k].push(new Permission().deserialize(p));
                });
            });
            deferred.resolve(perm);
        },
            e => deferred.reject(e));

        return deferred.promise;
    }

    getFormTemplateByType(orgId, templateType) {
        let deferred = this.$q.defer();
        let params = {
            orgId,
            templateType
        }

        this.api.get(APIs.GET_FORM_TEMPLATE_BY_TYPE.interpolate(params)).then(data => {
            deferred.resolve(data.data);
        },
            e => deferred.reject(e));

        /// For local testing of create team ///
        // this.$http.get('http://localhost:3000/teamsCstmAttr/aaicama-update-org-user').then(s => {

        //         deferred.resolve(s.data);
        // })
        /////////////////////////////////////////
        return deferred.promise;
    }
    getSectionTemplate(params, subjectId) {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_SECTION_TEMPLATE.interpolate({ subjectId }), params).then(data => {
            deferred.resolve(data.data);
        },
            e => deferred.reject(e));

        return deferred.promise;
    }
    getCstmAttrTemplate(orgId, subEntityType) {
        let deferred = this.$q.defer();
        let body = {
            "entityType": "SUBJECT",
            orgId,
            subEntityType
        }

        this.api.post(APIs.GET_CUSTOM_ATTR_TEMPLATE, body).then(data => {
            deferred.resolve(data.data);
        },
            e => deferred.reject(e));

        return deferred.promise;
    }

    getSubject(subjectId, password, includeCustomAttributes = false, includeCustomAttributesTemplate = false) {
        let deferred = this.$q.defer();
        let body = {
            "password": password
        }
        let queryParams = {};
        if (includeCustomAttributesTemplate) {
            queryParams['includeCustomAttributesTemplate'] = true;
        }
        if (includeCustomAttributes) {
            queryParams['includeCustomAttributes'] = true;
        }

        this.api.post(APIs.GET_SUBJECT_V2.interpolate({ subjectId }), body, queryParams).then(data => {
            /////////For local testing of custom attr///////////
            // this.$http.get('http://localhost:3000/teamsCstmAttr/aaicama-dshbd').then(s => {
            //         let sub = new Subject().deserialize(data);
            //        sub['customAttributeTemplate'] = s.data;
            //         deferred.resolve(sub);
            // })
            deferred.resolve(new Subject().deserialize(data));
        },
            e => deferred.reject(e))


        return deferred.promise;
    }

    getSubjects() {
        let deferred = this.$q.defer();
        let body = {
            "password": ''
        }

        this.api.post(APIs.GET_SUBJECTS_V2, body).then(data => {
            let allSubjects = [];

            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempSubject = new Subject().deserialize(data[i]);
                    allSubjects.push(tempSubject);
                }
            }

            let objResponse = {};
            objResponse['allSubjects'] = allSubjects;
            deferred.resolve(objResponse);
        });
        return deferred.promise;
    }

    //Fetch posts page wise
    getPostsV2(password, page, size, filter = null, sort = null) {
        let deferred = this.$q.defer();
        let body = {
            "page": page || 0,
            "size": size || 10,
            password
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": [sort.sortBy],
                "direction": sort.sortOrder
            };
        } else {
            body['sortOn'] = {
                "properties": [
                    "lastActionTime"
                ],
                "direction": "DESC"
            };
        }
        if (!!filter) {
            body['filter'] = filter;
        } else {
            body['filter'] = {};
        }

        this.api.post(APIs.POST_DOCUMENT_LIST_V2, body).then(
            data => {
                let subj = [];
                let resp = {};
                if (!!data['content']) {
                    let payload = data['content'];
                    payload.forEach((p) => {
                        let temp = new CachedDocument().deserialize(p);
                        if (!!temp)
                            subj.push(temp);
                    });
                }
                resp['totalElements'] = data['totalElements'];
                resp['posts'] = subj;
                deferred.resolve(resp);
            },
            e => {
                console.error('System error while fetching posts:', e);
                deferred.reject({ payload: e });
            }
        );
        return deferred.promise;
    }

    //Fetch subjects page wise
    getSubjectsV3(page, size, sort = null, filter = null, includeCustomAttributes = false, attributes = null, password = null, customFilter = null) {
        let deferred = this.$q.defer();
        let body = {
            "page": page || 0,
            "size": size || 10
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.properties,
                "direction": sort.direction
            };
        } else {
            body['sortOn'] = {
                "properties": ["frozen",
                    "formerMember",
                    "fullname",
                    "firstname"],
                "direction": "ASC"
            };
        }
        if (!!filter) {
            body['filter'] = filter;
        }
        if (!!customFilter) {
            body['customFilter'] = customFilter;
        }
        if (includeCustomAttributes) {
            body['extraParams'] = {
                includeCustomAttributes,
                attributes
            };
            body['password'] = password;
        }

        this.api.post(APIs.GET_SUBJECTS_V3, body).then(
            data => {
                let subj = [];
                let resp = {};
                if (!!data['content']) {
                    let payload = data['content'];
                    payload.forEach((p) => {
                        let temp = new Subject().deserialize(p);
                        if (!!temp)
                            subj.push(temp);
                    });
                }
                resp['totalElements'] = data['totalElements'];
                resp['subjects'] = subj;
                deferred.resolve(resp);
            },
            e => {
                console.error('System error while fetching subjects:', e);
                deferred.reject({ payload: e });
            }
        );
        return deferred.promise;
    }

    createSubject(paramSubject: Subject, password: any, isOnBehalf: boolean = false) {

        let body = JSON.parse(JSON.stringify(paramSubject));
        body.password = password;

        if (!!body.photo && body.photo.indexOf(',') != -1)
            body.photo = body.photo.split(',')[1];
        if (!isOnBehalf) {
            return this.api.post(APIs.CREATE_SUBJECT, body).then(data => {
                return new Subject().deserialize(data);
            });
        } else {
            return this.api.post(APIs.CREATE_SUBJECT_BEHALF, body).then(data => {
                return  new Subject().deserialize(data);
            })
        }
    }

    createMultiSubject(paramSubject: Subject[]) {
        let body = JSON.parse(JSON.stringify(paramSubject));
        return this.api.post(APIs.CREATE_SUBJECT_MULTI, body);
    }

    updateSubject(subject: Subject | SubjectPayload, password: any) {

        let body = JSON.parse(JSON.stringify(subject));
        if (!!body.photo && body.photo.indexOf(',') != -1)
            body.photo = body.photo.split(',')[1];
        body.password = password;

        let params = {
            "subjectId": body.subjectId
        };

        return this.api.patch(APIs.UPDATE_SUBJECT.interpolate(params), body).then(data => {
            return new Subject().deserialize(data);
        });
    }

    updateMultipleSubjects(subject: Subject[]) {
        let body = JSON.parse(JSON.stringify(subject));
        return this.api.patch(APIs.UPDATE_MULTIPLE_SUBJECT, body);
    }

    updateCstmAttr(subject: any, password: any) {
        let body = JSON.parse(JSON.stringify(subject));
        body.password = password;

        let params = {
            "subjectId": body.subjectId
        };

        return this.api.patch(APIs.UPDATE_SUBJECT_V2.interpolate(params), body).then(data => {
            //let subject = new Subject().deserialize(data);
            return data;
        });
    }

    createOrgUser(userDetails: any) {
        let body = JSON.parse(JSON.stringify(userDetails));
        return this.api.post(APIs.CREATE_ORG_USER, body).then(data => {
            return data;
        });
    }
    updateOrgUser(userDetails: any) {
        let body = JSON.parse(JSON.stringify(userDetails));
        return this.api.patch(APIs.UPDATE_ORG_USER, body).then(data => {
            return data;
        });
    }

    bulkAddUser(userId: number, userDetails: any) {
        let body = JSON.parse(JSON.stringify(userDetails));
        return this.api.post(APIs.BULK_ADD_TO_TEAMS.interpolate({ userId }), body).then(data => {
            return data;
        });
    }

    bulkRemoveUser(userId: number, userDetails: any) {
        let body = JSON.parse(JSON.stringify(userDetails));
        return this.api.post(APIs.BULK_REMOVE_FROM_TEAMS.interpolate({ userId }), body).then(data => {
            return data;
        });
    }

    deleteSubject(subjectId) {
        let deferred = this.$q.defer();

        this.api.delete(APIs.DELETE_SUBJECT.interpolate({ subjectId })).then(() => {
            deferred.resolve();
        }, e => deferred.reject(e));

        return deferred.promise;
    }

    removeOrgFromTeam(subjectId, orgId) {
        let deferred = this.$q.defer();
        let params = {
            "subjectId": subjectId,
            "orgId": orgId
        };

        this.api.delete(APIs.REMOVE_ORG_FROM_TEAM.interpolate(params), params).then((s) => {
            deferred.resolve(s);
        }, e => deferred.reject(e));

        return deferred.promise;
    }

    setupUserSignature(signatureText, initials, userId) {
        let body = { "signatureText": signatureText, "initials": initials };

        return this.api.post(APIs.SAVE_SIGNATURE.interpolate({ userId }), body).then(data => {
            return data;
        });
    }

    getDocumentSignatureTemplates() {

        return this.api.get(APIs.GET_SIGNATURE_TEMPLATE).then(data => {
            return data;
        });
    }

    createDocument(d : Document, sharedUsersIds? : number[], sharedPermissionTypes? : string[], password? : string) {
        let body = JSON.parse(JSON.stringify(d));
        if (!!password && !!sharedUsersIds && !!sharedPermissionTypes) {
            body.password = password;
            body.sharedUsersIds = sharedUsersIds.join(" ");
            body.shareTypes = sharedPermissionTypes.join(" ");
        }

        if (!!body.firstComment) {
            body.comment = '';

            body.firstComment = body.firstComment.replace(/\t/g, '&#9;');
        }

        delete body.attachments;
        delete body.subject;
        delete body.documentUsers;

        return this.api.post(APIs.CREATE_DOCUMENT.interpolate({ "subjectId": d.subjectId }), body).then(data => {
            return (new Document().deserialize(data));
        });
    }

    createFolder(userId, folderObj) {

        return this.api.post(APIs.CREATE_FOLDER.interpolate({ userId }), folderObj).then(data => {
            return new DocumentFolder().deserialize(data);
        });

    }

    updateFolder(userId, folderId, folderObj) {
        return this.api.put(APIs.UPDATE_FOLDER.interpolate({ userId, id: folderId }), folderObj).then(data => {
            return new DocumentFolder().deserialize(data);
        });
    }

    moveDocument(folderObj) {
        let params = {
            "id": folderObj.id,
            "parentId": folderObj.parentId
        }
        let url = APIs.docApis[folderObj.postType]["MOVE_DOCUMENT"];
        return this.api.patch(url.interpolate(params), params).then(data => {
            return data;
        });
    }

    copyDocument(folderObj) {
        let body = {
            "folderId": folderObj.folderId,
            "userId": folderObj.userId,
            "id": folderObj.id
        }
        let url = APIs.docApis[folderObj.postType]["COPY_RS_DOCUMENT"];
        return this.api.post(url, body).then(data => {
            return (new Document().deserialize(data));
        });
    }
    createDocumentSignature(d, documentId) {
        let body = JSON.parse(JSON.stringify(d));

        return this.api.post(APIs.CREATE_DOCUMENT_SIGNATURE.interpolate({ documentId }), body).then(data => {
            return data;
        });
    }

    updatePDFwithSignature(password, documentId, userId) {
        let body = JSON.parse(JSON.stringify({ password: password }));
        let deferred = this.$q.defer();

        this.api.post(APIs.UPDATE_PDF_WITH_SIGNATURE.interpolate({ documentId, userId }), body).then(
            (s) => {
                deferred.resolve(s);
            },
            (e => {
                let errors;
                if (e && e.errorMessage) {
                    errors = e.errorMessage;
                } else {
                    errors = [];
                    for (let err of e) {
                        let error = new ErrorTransaction().deserialize(err);
                        if (!!error)
                            errors.push(error);
                    }
                }
                console.log('error while signing');
                deferred.reject(errors);
            }));
        return deferred.promise;
    }

    stageTheDocumentSignatureData(paramObj, data) {
        let body = JSON.parse(JSON.stringify(data));
        let params = {
            "documentId": paramObj.documentId,
            "groupId": paramObj.groupId,
            "userId": paramObj.userId
        };

        return this.api.patch(APIs.STAGE_DOCUMENT_SIGNATURE.interpolate(params), body).then(data => {
            return data;
        });
    }

    createDiscussionComment(d, password, documentId) {

        let params = {
            "documentId": documentId
        };

        let body = {
            "comment": d.comment.replace(/\t/g, '&#9;'),
            "password": password
        };

        return this.api.post(APIs.CREATE_COMMENT.interpolate(params), body).then(data => {
            return new DiscussionComment().deserialize(data);
        });
    }

    // Edit an existing comment. Request payload matches createDiscussionComment (same
    // comment/password body); response is the same shape plus isEdited/editedTime flags.
    updateDiscussionComment(comment, password, documentId, commentId) {

        let params = {
            "documentId": documentId,
            "commentId": commentId
        };

        let body = {
            "comment": comment.replace(/\t/g, '&#9;'),
            "password": password
        };

        return this.api.put(APIs.UPDATE_COMMENT.interpolate(params), body).then(data => {
            return new DiscussionComment().deserialize(data);
        });
    }

    // Soft-delete a comment. No request payload is required; response carries deleted: true.
    deleteDiscussionComment(documentId, commentId) {

        let params = {
            "documentId": documentId,
            "commentId": commentId
        };

        return this.api.delete(APIs.DELETE_COMMENT.interpolate(params)).then(data => {
            return new DiscussionComment().deserialize(data);
        });
    }


    getDiscussion(documentId, password) {
        let deferred = this.$q.defer();


        this.api.post(APIs.GET_DISCUSSION.interpolate({ documentId }), { "password": password }).then(data => {
            console.log(data);
            let tempDoc = new Discussion().deserialize(data);

            this._fillDiscussionMembers(tempDoc.id, tempDoc).then(
                (s) => {
                    deferred.resolve(s);
                }
            )
        }, e => deferred.reject(e));
        return deferred.promise;
    }

    getDocument(documentId, password, type?) {
        let deferred = this.$q.defer();
        let body = {};

        if (!!type) {
            body = {
                "password": password,
                partName: "parentDoc",
                "documentType": type
            };
        } else {
            body = {
                "password": password,
                partName: "parentDoc"
            };
        }

        this.api.post(APIs.GET_DISCUSSION.interpolate({ documentId }), body).then(s => {
            console.log(s);
            let tempDoc = new Document().deserialize(s);
            deferred.resolve(tempDoc);
        }, e => deferred.reject(e));

        return deferred.promise;
    }


    _fillDiscussionMembers(discussionId, discussion) {
        let deferred = this.$q.defer();


        this.getDocumentUsers(discussionId).then(
            (users) => {
                discussion.members = users;

                deferred.resolve(discussion);
            }
            , (error) => {
                deferred.resolve(discussion);
            }
        );
        return deferred.promise;
    }

    // Handle deffered.reject
    getDiscussions(subjectId?, userId?, password?) {
        let deferred = this.$q.defer();
        let queryParams : {
            documentType: string,
            subjectId?: number
        } = {
            documentType: 'DISCUSSION'
        };
        if (!!subjectId)
            queryParams.subjectId = subjectId;
        this.api.get(APIs.GET_DOCUMENTS_OR_DISCUSSIONS.interpolate({ userId }), queryParams).then((data) => {
            let discussions = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempDoc = new Discussion().deserialize(data[i]);
                    discussions.push(tempDoc);
                }

                deferred.resolve(discussions);
            }
            //return discussions;
        }).catch((e) => {
            deferred.reject(e);
        }
        );
        return deferred.promise;
    }


    deleteDocument(id, postType) {
        let docDeleteApi = APIs.docApis[postType]["DELETE_DOCUMENT"];
        let url = docDeleteApi.url;
        let method = docDeleteApi.method;
        return this.api[method](url.interpolate({ id }));
    }


    getDocuments( userId, type , subjectId?, resultOrder?, resultSize?, incId?, withDiscussion?, withCommentsOnly?, loadMore?, lastUpdatedTime?, fetchSystemComments?) {

        let queryParamsObj = {};

        if (!!resultOrder && !!resultSize) {
            queryParamsObj["resultOrder"] = resultOrder;
            queryParamsObj["resultSize"] = resultSize;
            if (!!incId)
                queryParamsObj["id"] = incId;
        }
        if (!!withDiscussion && !!withCommentsOnly) {
            queryParamsObj["commentsCount"] = 0;
        } else if (withDiscussion != true) {
            queryParamsObj["filename"] = 'required';
        }
        if (!!subjectId) {
            queryParamsObj["subjectId"] = subjectId; /*= {
                    "documentType": type,
                    : subjectId
                };*/
        }

        if (!!type) {
            queryParamsObj["documentType"] = type;
        }

        if (!!loadMore) {
            queryParamsObj["loadMore"] = loadMore;
        } else {
            queryParamsObj["loadMore"] = false;
        }

        if (!!lastUpdatedTime) {
            queryParamsObj["lastActionTime"] = lastUpdatedTime;
        }

        if (!!fetchSystemComments) {
            queryParamsObj["fetchSystemComments"] = fetchSystemComments;
        }
        return this.api.get(APIs.GET_DOCUMENTS_OR_DISCUSSIONS.interpolate({ userId }), queryParamsObj).then((data) => {
            let docs = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempDoc;
                    if (!!withDiscussion) {
                        tempDoc = new Discussion().deserialize(data[i]);
                    } else {
                        tempDoc = new Document().deserialize(data[i]);
                    }

                    if (!!tempDoc.comments && tempDoc.comments.length > 0) {
                        tempDoc.commentsCount = tempDoc.comments.filter(comment => !comment.commentType || comment.commentType == 'USER_DEFINED').length;
                    }
                    docs.push(tempDoc);
                }
            }
            return docs;
        });
    }

    //Call to fetch all the documents for the logged-in user
    // fetchAllDocuments(userId) {
    //     return this.api.get(APIs.FETCH_ALL_DOCS.interpolate({ userId })).then((data) => {
    //         let docs = [];
    //         if (!!data) {
    //             for (let i = 0; i < data.length; i++) {
    //                 let tempDoc;
    //                 tempDoc = new Discussion().deserialize(data[i]);
    //                 docs.push(tempDoc);
    //             }
    //         }
    //
    //         return docs;
    //     });
    // }

    checkPassword(password) {
        return this.api.post(APIs.CHECK_PASSWORD, {
            "password": password
        }).then((data) => new User().deserialize(data));
    }

    checkToken(token) {
        let body = {
            "token": token
        };
        return this.api.post(APIs.CHECK_INVITATION_TOKEN, body).then(user => (new User().deserialize(user)));
    }

    processInvitation(token, generatedCode, orgId?, serviceId?) {
        let body = {
            "code": generatedCode,
            "token": token
        }
        if (!!orgId) {
            body['organizationId'] = orgId;
        }
        if (!!orgId) {
            body['serviceId'] = serviceId;
        }
        return this.api.put(APIs.PROCESS_INVITATION, body);
    }

    checkIfVaultKeyResetRequired() {
        return this.api.get(APIs.VAULT_KEY_RESET_REQ);
    }

    policyAccepted(acceptedPrivacy: boolean, acceptedTerms: boolean, acceptedGdpr: boolean, userId: number) {
        return this.api.post(APIs.UPDATE_POLICY.interpolate({ userId }), {
            "acceptedPrivacy": acceptedPrivacy,
            "acceptedTerms": acceptedTerms,
            "acceptedGdpr": acceptedGdpr
        });
    }

    getDocumentUsers(documentId) {
        return this.api.get(APIs.GET_DOCUMENT_USERS.interpolate({ documentId })).then((data) => {
            let users = [];
            for (let i = 0; i < data.length; i++) {
                let tempUser = new User().deserialize(data[i]);
                if (!!tempUser)
                    users.push(tempUser);
            }
            return users;
        });

    }

    shareDocument(documentId, password, userShareMap, orgShareMap, postType, rsDoc?, subjectId?) {
        if (rsDoc) {
            let url = APIs.docApis[postType]["SHARE_RS_DOCUMENT"];
            if (postType == PostTypeEnums.DOCUMENT) {
                return this.api.post(url.interpolate({ documentId }), {
                    "sharedUsersIds": Object.keys(userShareMap).join(' '),
                    "password": password,
                    "shareTypes": Object.keys(userShareMap).map(key => userShareMap[key]).join(' '),
                    "sharedOrgIds": Object.keys(orgShareMap).join(' '),
                    "shareTypesOrgs": Object.keys(orgShareMap).map(key => orgShareMap[key]).join(' '),
                    subjectId
                });
            }
            return this.api.post(url, {
                "id": documentId,
                "subjectId": subjectId,
                "orgShareMap": orgShareMap,
                "userShareMap": userShareMap
            });

        }
        let url = APIs.docApis[postType]["SHARE_DOCUMENT"];
        if (postType == PostTypeEnums.LINK) {
            return this.api.post(url, {
                "id": documentId,
                "subjectId": subjectId,
                "orgShareMap": orgShareMap,
                "userShareMap": userShareMap
            })
        }
        return this.api.post(url.interpolate({ documentId }), {
            "sharedUsersIds": Object.keys(userShareMap).join(' '),
            "password": password,
            "shareTypes": Object.keys(userShareMap).map(key => userShareMap[key]).join(' '),
            "sharedOrgIds": Object.keys(orgShareMap).join(' '),
            "shareTypesOrgs": Object.keys(orgShareMap).map(key => orgShareMap[key]).join(' ')
        });
    }

    sendInviteToProvider(subjectId, emailAddress, url, password, htmlEmailTemplate?, role?, userProfileId?, personalMsg?, inviteWithCoCaptain?: boolean, isInviteeFormerMember?: boolean) {
        let profileId = null;
        if (!!userProfileId)
            profileId = userProfileId;
        let message = null;
        if (!!personalMsg) {
            message = personalMsg;
        }
        let body = {
            "targetEmail": emailAddress,
            "redeemPath": '/#/ecare-vault/login?for=provider&',
            "subjectId": subjectId,
            "send": true,
            "userProfileId": profileId,
            "message": message,
            "coCaptain": (inviteWithCoCaptain == true),
            "isInviteeFormerMember": !!isInviteeFormerMember,
            "password": password
        };

        if (!!role && role == 'teammember') {
            body.redeemPath = '/#/ecare-vault/login?for=teammember&';
        }

        return this.api.post(APIs.SEND_INVITATION_TO_PROVIDER, body);
    }

    suggestProvider(subjectId, userProfileId, emailAddress) {
        return this.api.post(APIs.SUGGEST_PROVIDER, {
            "userProfileId": userProfileId,
            "targetEmail": emailAddress,
            "subjectId": subjectId
        });
    }

    getSuggestions() {
        return this.api.get(APIs.GET_SUGGESSIONS);
    }

    processSuggestion(subjectId, email, send, token, redeemPath, inviteDate, invitedBy, invitedById, message?) {
        let body = {
            "subjectId": subjectId,
            "targetEmail": email,
            "send": send,
            "token": token,
            "redeemPath": redeemPath,
            "inviteDate": inviteDate,
            "invitedBy": invitedBy,
            "invitedById": invitedById,
            "message": null
        };
        if (!!message) {
            body.message = message;
        }
        return this.api.post(APIs.PROCESS_SUGGESTION, body);
    }


    sendInvite(subjectId : number, emailAddress : string, url : string, htmlEmailTemplate? : string) {
        // let emailTemplate : string;
        // if (!!htmlEmailTemplate)
        //     emailTemplate = htmlEmailTemplate;
        // else
        //     emailTemplate = '<h2>Hello</h2>, parent of ${SUBJECT_FIRST} ${SUBJECT_LAST}. <br/> Please login to eCareVault using this URL : ' + url + '?i=${TOKEN}.';
        let body = {
            "targetEmail": emailAddress,
            "redeemPath": '/#/ecare-vault/login?for=parent&',
            "subjectId": subjectId,
            "send": true
        };
        return this.api.post(APIs.SEND_INVITATION, body);
    }

    getTeamRoles(orgId?: number) {
        let queryParams = {};
        if (orgId) {
            queryParams['orgId'] = orgId;
        }
        return this.api.get(APIs.GET_TEAMROLES, queryParams).then((data) => {
            if (!!data) {
                return data;
            } else {
                return null;
            }
        });

    }

    getDocumentTypes() {
        return this.api.get(APIs.GET_DOCUMENT_TYPES).then((data) => {
            if (!!data) {
                return data;
            } else {
                return null;
            }
        });
    }

    getProjectTypes() {
        return this.api.get(APIs.GET_PROJECT_TYPES).then((data) => {
            if (!!data) {
                return data;
            } else {
                return null;
            }
        });
    }

    validateSignup(email, token, code) {
        return this.api.post(APIs.VALIDATE_PRE_SIGNUP, {
            providerIdentity: email,
            token: token,
            code: code
        });
    }


    transferTeamOwnership(subjectId, teamMemberId, isExit) {
        return this.api.post(APIs.TRANSFER_OWNERSHIP.interpolate({ subjectId }), {
            "invitedMemberId": teamMemberId,
            "exitTeam": isExit
        });
    }

    //check wheather any transfer ownership request for logged-in user
    getTransferOwnershipRequest(subjectId : number | string) {
        let queryParamsObj = subjectId ? `?subjectId=${subjectId}` : ""
        console.log("apiCalll", `${APIs.GET_TRANSFER_OWNERSHIP_REQUEST}${queryParamsObj}`, subjectId)
        return this.api.get(`${APIs.GET_TRANSFER_OWNERSHIP_REQUEST}${queryParamsObj}`);
    }

    //process ownership transfer request
    processTransferOwnershipRequest(requestObject, accepted) {
        return this.api.post(APIs.PROCESS_TRANSFER_OWNERSHIP.interpolate({ subjectId: requestObject.subjectId }), {
            "invitedMemberId": requestObject.invitedMemberId,
            "accepted": accepted,
            "id": requestObject.id,
            "ownerId": requestObject.ownerId
        });
    }

    //process reminder transfer request
    processReminderRequestForOwnership(requestObject) {
        return this.api.post(APIs.PROCESS_TRANSFER_OWNERSHIP.interpolate({ subjectId: requestObject.subjectId }), {
            "invitedMemberId": requestObject.invitedMemberId,
            "id": requestObject.id,
            "remind": true,
            "ownerId": requestObject.ownerId
        });
    }

    //process ownership transfer request
    updateOwnershipRecord(requestObject, isDeleted) {
        return this.api.post(APIs.UPDATE_OWNERSHIP_RECORD.interpolate({ subjectId: requestObject.subjectId }), {
            "id": requestObject.id,
            "isDeleted": true
        });
    }

    exitTeam(subjectId, userId) {
        return this.api.post(APIs.EXIT_TEAM.interpolate({ subjectId }), {
            "id": userId
        });
    }

    //one user get alert disable the alert for next time
    updateUserNotificationAlertFlag(userNotification) {
        return this.api.post(APIs.UPDATE_USER_NOTIFICATION_FLAG, {
            "id": userNotification.id,
            "isDeleted": true
        });
    }

    initBackupPasswordReset(user: User) {
        return this.api.put(APIs.INIT_BACKUP_PWD_RESET, {
            "id": user.id
        });
    }

    doBackupPasswordReset(user: User) {
        return this.api.post(APIs.BACKUP_PASSWORD_RESET, {
            "id": user.id,
            "token": user.token,
            "code": user.code,
            "password": user.password
        });
    }


    //Request to send another invite if invitation expired
    requestAnotherInvite(token: string) {
        return this.api.post(APIs.REQUEST_NEW_INVITE, {
            "token": token
        });
    }

    //Delete invited Team Member
    deleteInvitedMember(providerId, providerIdentity, token) {
        return this.api.post(APIs.DELETE_INVITED_TM.interpolate({ providerId }), {
            "providerIdentity": providerIdentity,
            "token": token
        });
    }

    //Update a document - update the title
    updateDocumentTitle(documentId, title, desc, postType) {
        let url = APIs.docApis[postType]["UPDATE_TITLE"];
        if (postType == PostTypeEnums.LINK) {
            return this.api.post(url.interpolate({ linkId: documentId }), {
                "title": title
            });
        }
        return this.api.put(url.interpolate({ documentId }), {
            "title": title,
            "comment": !!desc ? desc : '$$DELETE$$'
        });
    }

    //get user types
    getUserTypes() {
        return this.api.get(APIs.GET_USER_TYPES);
    }

    getUsersById(ids: number[]): ng.IPromise<UserList> {
        return this.api.post(APIs.GET_USERS_BY_ID, { ids }).then((data) => {
            return new UserList().deserialize(data);
        });
    }

    getSubjectsById(ids: number[]): ng.IPromise<Subject[]> {
        return this.api.post(APIs.GET_SUBJECTS_V2, { ids }).then((data) => {
            let allSubjects = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempSubject = new Subject().deserialize(data[i]);
                    allSubjects.push(tempSubject);
                }
            }
            return allSubjects;
        });
    }

    getPartySubjectsById(ids: number[] = null, schoolIds: number[] = null, fetchProviderSubject = false) {
        return this.api.post(APIs.GET_SUBJECTS_BY_ID_1, { ids, schoolIds, fetchProviderSubject }).then((data) => {
            let subjects = [];
            angular.forEach(data['subjects'], (sub: Subject) => {
                subjects.push(new Subject().deserialize(sub));
            });
            return subjects;
        });
    }

    getSearchResults(params: SearchResult): angular.IPromise<SearchResult[]> {
        let body = JSON.parse(JSON.stringify(params));
        return this.api.post(APIs.SEARCH, body).then((data) => {
            let results: SearchResult[] = [];
            for (let sr of data) {
                delete sr.keyword;
                results.push(new SearchResult().deserialize(sr));
            }
            return results;
        });
    }

    //get care details
    getCareDetails(subjectTypeId: any) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_CARE_DETAILS, {
            'subjectType': subjectTypeId
        }).then((data) => {
            let crDetails = data.map(function (item) {
                return new CareDetail().deserialize(item);
            });
            deferred.resolve(crDetails);
        }).catch(e => {
            deferred.reject(e)
        });
        return deferred.promise;
    }

    //get CR profile
    getCrProfile(subjectId) {
        return this.api.get(APIs.GET_CR_PROFILE.interpolate({ subjectId })).then(data => new CrProfile().deserialize(data));
    }

    // update CR profile
    updateCrProfile(crProfile) {
        return this.api.patch(APIs.UPDATE_CR_PROFILE.interpolate({ subjectId: crProfile.subjectId }), {
            "about": crProfile.about,
            "subjectId": crProfile.subjectId,
            "subjectCareDetails": crProfile.subjectCareDetails
        }).then(data => new CrProfile().deserialize(data));
    }

    // fetch subject images
    getSubjectImages(subjectId) {
        return this.api.get(APIs.GET_SUBJECT_IMAGES.interpolate({ subjectId })).then(data => {
            return data.map(function (item) {
                //Update the newlyAdded flag
                item.isNewlyAdded = false;
                return new SubjectImage().deserialize(item);
            });
        });
    }

    // add subject image
    addSubjectImage(subjectId, subjectImage) {
        return this.api.post(APIs.ADD_SUBJECT_IMAGES.interpolate({ subjectId }), {
            "photo": subjectImage.photo,
            "deleted": subjectImage.isDeleted,
            "sortOrder": subjectImage.sortOrder,
            "isNewlyAdded": subjectImage.isNewlyAdded
        }).then(data => new SubjectImage().deserialize(data));
    }

    // update subject images
    updateSubjectImages(subjectId, subjectImages) {
        return this.api.patch(APIs.UPDATE_SUBJECT_IMAGES.interpolate({ subjectId }), {
            "subjectPhotoList": subjectImages
        }).then(data => data.map((item) => new SubjectImage().deserialize(item)));
    }

    // get shareable link
    getShareableLink(documentId, documentType, password, signedCopy, postType) {
        let docShareableLinkApi = APIs.docApis[postType]["GET_SHARABLE_LINK"];
        let url = docShareableLinkApi.url;
        let method = docShareableLinkApi.method;

        if (postType == PostTypeEnums.LINK) {
            return this.api[method](url.interpolate({ linkId: documentId }), {}).then(data => new ShareableLink().deserialize(data));
        } else {
            return this.api[method](url.interpolate({ documentId }), {
                "password": password,
                "documentType": documentType,
                "signedCopy": signedCopy
            }).then(data => new ShareableLink().deserialize(data));
        }
    }

    // get shared document
    getSharedDocument(code, postType) {
        let url = APIs.docApis[postType]["GET_SHARED_DOCUMENT"];
        return this.api.get(url.interpolate({ code }), null, false).then(data => new Discussion().deserialize(data));
    }

    // download shared document
    downloadSharedDocument(code) {
        return this.api.get(APIs.DOWNLOAD_SHARED_DOCUMENT.interpolate({ code }), null, false).then(data => new Discussion().deserialize(data));
    }

    //update shared document'dataviewed flag
    updateNotificationFlags(notifications) {
        return this.api.post(APIs.UPDATE_NOTIFICATION_FLAGS, notifications);
    }


    //update shared document'dataviewed flag
    updateViewedFlag(userId: number, notificationIds) {
        return this.api.post(APIs.MARK_NOTIFICATION_AS_VIEWED.interpolate({ userId }), notificationIds);
    }

    // fetch unread notifications
    fetchNotifications(password, pageNo = 0, size = 10, filter = {}, sortOn?) {
        let queryParams = {
            "page": pageNo,
            "size": size,
            "password": password,
            "sortOn": sortOn ? sortOn : {
                "properties": [
                    "id"
                ],
                "direction": "DESC"
            },
            filter: filter
        }
        return this.api.post(APIs.FETCH_NOTIFICATIONS, queryParams).then(data => new Notification().deserialize(data));
    }
    fetchUsers(orgId, pageNo = 0, size = 10, sort = null, filter = null) {
        let body = {
            "page": pageNo,
            "size": size
        }
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.properties,
                "direction": sort.direction
            };
        }
        if (!!filter) {
            body['filter'] = filter;
        }
        return this.api.post(APIs.GET_USERS.interpolate({ orgId }), body).then(data => {
            return data
        });
    }

    checkUser(userId) {
        return this.api.get(APIs.CHECK_USER.interpolate({ userId })).then(data => {
            return data
        });
    }

    deactivateUser(userId: number, params) {
        return this.api.post(APIs.DEACTIVATE_USER.interpolate({ userId }), params);
    }

    teamCoCaptainAction(subjectId, providerId, isCoCaptain) {
        return this.api.post(APIs.TEAM_CO_CAPTAIN_ACTION.interpolate({ subjectId, providerId }), {
            "coCaptain": isCoCaptain
        });
    }

    getLeaCampus(orgId, key, dateSubmitted = 0) {
        let queryParams = {
            "key": key
        };
        if (dateSubmitted != 0) {
            queryParams['dateSubmitted'] = dateSubmitted;
        }
        return this.api.get(APIs.GET_LEA_CAMPUS.interpolate({ orgId }), queryParams).then(data => {
            let rtnData = [];
            data.forEach(d => {
                rtnData.push(new SelectOption(d.partyId, d.name, d.parentId));
            });
            return rtnData;
        });
    }

    getSchoolsForReport(orgId, checkPermission = false) {
        return this.api.get(APIs.GET_SCHOOLS_FOR_REPORT.interpolate({ orgId }), {
            "checkPermission": checkPermission
        }).then(data => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new SelectOption(d.partyId, d.name))
                });
            }
            return rtnData;
        });
        // return this.$http.get('http://jeavio.dev.ecarevault.com.s3-website-us-east-1.amazonaws.com:3000/get/slist').then(data => {
        //     return data.data;
        // });
    }

    getGradesForReport(body = []) {
        return this.api.post(APIs.GET_GRADES, body).then((data) => {
            let rtnData = [];
            if (Array.isArray(data)) {
                let grades = _.groupBy(data, 'gradeDisplay')
                _.each(grades, (value, key) => {
                    rtnData.push(new SelectOption(JSON.stringify(_.map(value, 'id')), key));
                });
            }
            return rtnData;
        });
    }

    getProvidersForReport(schools, grades, orgId, roleName, reportName = "", startDate = null, endDate = null, status = null, subjectIds = null) {
        let queryParams = {
            "roleName": roleName,
            "reportName": reportName
        };
        return this.api.post(APIs.GET_PROVIDERS_FOR_REPORT.interpolate({
            "orgId": orgId
        }), { schools, grades, startDate, endDate, status, subjectIds }, queryParams).then((data) => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new User().deserialize(d));
                });
            }
            return rtnData;
        });
        // return this.$http.get('http://jeavio.dev.ecarevault.com.s3-website-us-east-1.amazonaws.com:3000/get/plist').then(data => {
        //     return data.data;
        // });
    }

    getSubjectsForOrg(orgId) {
        return this.api.get(APIs.GET_SUBJECTS_OF_ORG.interpolate({ orgId })).then((data) => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new Subject().deserialize(d));
                });
            }
            return rtnData;
        });
    }

    getGoalCateogries() {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_CATEGORIES, {
            entityName: "goals",
            entityType: "FORMDYNAMICATTRIBUTE",
            metadata: "Category"
        }).then((data) => {
            let cats = [];
            if (Array.isArray(data) && !!data[0] && !!data[0].listOptions) {
                try {
                    let categories = JSON.parse(data[0].listOptions);
                    categories.forEach(c => {
                        cats.push(new SelectOption(c.id, c.name));
                    })
                } catch (e) {
                    console.log(e);
                }
            }
            deferred.resolve(cats);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    getStudentGrades(schoolId, isForReport = false) {
        return this.api.get(APIs.GET_STUDENT_GRADES.interpolate({ schoolId })).then((data) => {
            let rtnData = [];
            if (Array.isArray(data)) {
                if (!isForReport) {
                    if (data.length > 0) {
                        rtnData.push(new StudentGrade(-1, NULL_TEXT));
                    }
                    data.forEach(d => {
                        rtnData.push(new StudentGrade(d.id, d.gradeDisplay));
                    });
                } else {
                    data.forEach(d => {
                        rtnData.push(new SelectOption(d.id, d.gradeDisplay));
                    });
                }
            }
            return rtnData;
        });
    }

    userStats() {
        return this.api.get(APIs.GET_USER_STATS);
    }

    createDocumentMetadata(d, folderId, sharedUsersIds?, userShareTypes?, password?) {
        let body = JSON.parse(JSON.stringify(d));
        if (!!password && !!sharedUsersIds) {
            body.password = password;
            body.sharedUsersIds = (sharedUsersIds || "").substring(0, sharedUsersIds.length - 1).split(" ").join();
            body.userShareTypes = (userShareTypes || "").substring(0, userShareTypes.length - 1).split(" ").join();
        }

        if (!!body.firstComment) {
            body.comment = '';
        }
        body.documentFolderId = folderId;

        delete body.subject;
        delete body.displayAs;
        delete body.attachments;
        delete body.documentUsers;

        return this.api.post(APIs.CREATE_DOCUMENT_METADATA.interpolate({ subjectId: d.subjectId }), body).then(data => new Discussion().deserialize(data));
    }

    createRSDocumentMetadata(d, folderId) {
        let body = JSON.parse(JSON.stringify(d));
        body.documentFolderId = folderId;

        delete body.subject;
        delete body.displayAs;
        delete body.attachments;
        delete body.documentUsers;
        let url = APIs.docApis[body.postType]["CREATE_RS"];
        return this.api.post(url, body).then(data => new Discussion().deserialize(data));


    }

    getVKResetInfo(user: User) {
        return this.api.post(APIs.GET_VK_RESET_INFO, JSON.parse(JSON.stringify(user)), null, false).then(data => new User().deserialize(data));
    }

    getValidationPolicy(email, token, type, code?) {
        return this.api.post(APIs.GET_PWD_POLICIES, {
            email: email,
            token: token,
            type: type,
            code: code || ""
        }).then((data) => {
            let obj = {
                passwordPolicy: [],
                vaultKeyPolicy: [],
                resetPasswordPolicy: [],
                resetVaultKeyPolicy: []
            };
            if ((type & PolicyTypeEnum.PASSWORD_POLICY) == PolicyTypeEnum.PASSWORD_POLICY && Array.isArray(data.passwordPolicy)) {
                data.passwordPolicy.forEach((p) => {
                    let pp = new ValidationPolicy().deserialize(p);
                    if (!!p) {
                        obj.passwordPolicy.push(pp);
                    }
                });
            }
            if ((type & PolicyTypeEnum.VAULT_KEY_POLICY) == PolicyTypeEnum.VAULT_KEY_POLICY && Array.isArray(data.vaultKeyPolicy)) {
                data.vaultKeyPolicy.forEach((p) => {
                    let vkp = new ValidationPolicy().deserialize(p);
                    if (!!vkp) {
                        obj.vaultKeyPolicy.push(vkp);
                    }
                });
            }
            if (Array.isArray(data.resetPasswordPolicy)) {
                data.resetPasswordPolicy.forEach((p) => {
                    let rpp = new ValidationPolicy().deserialize(p);
                    obj.resetPasswordPolicy.push(rpp);
                });
            }
            if (Array.isArray(data.resetVaultKeyPolicy)) {
                data.resetVaultKeyPolicy.forEach((p) => {
                    let rvkp = new ValidationPolicy().deserialize(p);
                    if (!!rvkp) {
                        obj.resetVaultKeyPolicy.push(rvkp);
                    }
                });
            }
            return obj;
        });
    }

    getDocumentLink(documentId, password, type?, isConvertedPdf?: boolean, downloadSignedCopy?: boolean, signing?: boolean, isMobile?: boolean) {
        let deferred = this.$q.defer();
        let body = {};

        if (!!type) {
            body = {
                "password": password,
                "partName": "",
                "documentType": type,
                "isConvertedPdf": !!isConvertedPdf,
                "signedCopy": !!downloadSignedCopy,
                "signing": !!signing,
                "isMobile": isMobile
            };
        } else {
            body = {
                "password": password,
                partName: ""
            };
        }
        this.api.post(APIs.GET_DOCUMENT_LINK.interpolate({ documentId }), body).then(data => {
            deferred.resolve(data);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    //get Team Member list to filter while adding Team Member
    searchTeamMember() {
        let deferred = this.$q.defer();
        this.api.get(APIs.SEARCH_TEAM_MEMBER).then(data => {
            let providers = [];
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    let tempProvider = new User().deserialize(data[i]);
                    if (!!tempProvider)
                        providers.push(tempProvider);
                }
            }
            deferred.resolve(providers);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    // fetch all plans
    getPlans(fetchAllPlans?: boolean) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_PLAN, {
            'fetchAllPlans': (!!fetchAllPlans ? fetchAllPlans : false)
        }).then(data => {
            let plans = []
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    let plan = new Plan().deserialize(data[i]);
                    if (!!plan)
                        plans.push(plan);

                }
            }
            deferred.resolve(plans);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    getCurrentSubscribePlanForUser(actualPlanLimit: boolean) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_USER_SUBSCRIPTION, { actualPlanLimit }).then(data => {
            let plan = new Plan().deserialize(data);
            deferred.resolve(plan);
        }).catch((e) => {
            console.log('error while execute payment');
            deferred.reject(e);
        });

        return deferred.promise;
    }

    enterpriseFeatures() {
        return this.api.get(APIs.GET_ENTERPRISE_FEATURES);
    }

    // fetch documents for auto share
    getAutoshareChecklist(subjectId) {
        return this.api.get(APIs.GET_AUTO_SHARE_CHECK_LIST.interpolate({ subjectId }));
    }

    getAvailableForms(page, size, sort, filter) {
        let deferred = this.$q.defer();
        let body = {
            'page': page || 0,
            'size': size || 10
        }
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }
        if (!!filter) {
            body['filter'] = { "subjectId": filter.subjectId }
        }
        this.api.post(APIs.GET_AVAILABLE_FORMS, body).then((data) => {
            let resp = {};
            let payload = [];
            if (!!data['content']) {
                payload = data['content'];
            }
            resp['totalElements'] = data['totalElements'];
            resp['forms'] = payload;
            deferred.resolve(resp);
        }).catch((e) => {
            console.error('System error while fetching available forms:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    //Fetch the list of all availabe services
    getAvailableServices(page, size, sort) {
        let deferred = this.$q.defer();
        let body = {
            "page": page || 0,
            "size": size || 10
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }
        this.api.post(APIs.GET_AVAILABLE_SERVICE, body).then((data) => {
            let services = [];
            let resp = {};
            if (!!data['content']) {
                let payload = data['content'];
                payload.forEach((p) => {
                    let temp = new Service().deserialize(p);
                    if (!!temp)
                        services.push(temp);
                });
            }
            resp['totalElements'] = data['totalElements'];
            resp['services'] = services;
            deferred.resolve(resp);
        }).catch(e => {
            console.error('System error while fetching service:', e);
            deferred.reject({ payload: e });
        });

        return deferred.promise;
    }

    //Fetch the list of all enterprise Service types Units
    getEnterpriseServiceUnitTypes() {
        return this.api.get(APIs.GET_SERVICE_UNIT_TYPES);
    }

    //Fetch the list of all enterprise Service Optiions
    getEnterpriseServiceOptions() {
        return this.api.get(APIs.GET_SERVICE_OPTION, {
            "onlyDefaultOptions": true
        });
    }

    //Fetch the list of all enterprise Service Options for org
    getServiceOptionsForOrg(orgId) {
        return this.api.get(APIs.GET_SERVICE_OPTION_ORG.interpolate({ orgId }));
    }

    //Fetch the list of all enterprise Service types
    getEnterpriseServicesTypes() {
        return this.api.get(APIs.GET_SERVICE_TYPES);
    }

    //Fetch the list of all enterprise Provider types
    getEnterpriseProviderTypes() {
        return this.api.get(APIs.GET_ENTERPRISE_PROVIDER_TYPE);
    }

    //To Create New service
    createNewService(newService: Object) {
        return this.api.post(APIs.CREATE_SERVICE, newService);
    }

    //Fetch the list of all Service Notes
    getServiceNotes(assignmentId: number, page, size, sort) {
        let deferred = this.$q.defer();
        let body = {
            "page": page || 0,
            "size": size || 10
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }
        this.api.post(APIs.GET_SERVICE_NOTES.interpolate({ id: assignmentId }), body).then(data => {
            let services = [];
            let resp = {};
            if (!!data['content']) {
                let payload = data['content'];
                payload.forEach((p) => {
                    let temp = new ServiceNote().deserialize(p);
                    if (!!temp)
                        services.push(temp);
                });
            }
            resp['totalElements'] = data['totalElements'];
            resp['services'] = services;
            deferred.resolve(resp);
        }).catch(e => {
            console.log('error while fetching service notes');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    getServiceNoteFromId(assignmentId: number, noteId: number) {
        return this.api.get(APIs.GET_SERVICE_NOTE_FORM_BY_ID.interpolate({ id: assignmentId, noteId: noteId })).then((data) => new ServiceNote().deserialize(data));
    }

    validateUnAssignedForm(data: any, id: number) {
        let deferred = this.$q.defer();
        this.api.post(APIs.VALIDATE_FORM, {
            "fields": data,
            "id": id
        }).then((data) => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('error while validating unassigned form');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    //Fetch the list of all Service Notes
    getServiceNoteTypes(assignmentId: number) {
        return this.api.get(APIs.GET_SERVICE_NOTE_TYPES.interpolate({ id: assignmentId }));
    }

    getReportsList(orgId, userPartyId) {
        let queryParams = {
            orgId: orgId,
            userPartyId: userPartyId
        }
        return this.api.get(APIs.GET_REPORT_LIST, queryParams);

        // let deferred = this.$q.defer();
        // this.$http.get('http://localhost:3000/get/report-list').then(data => {
        //     deferred.resolve(data.data);
        // });
        // return deferred.promise;
    };

    getReportConfiguration(reportId) {
        return this.api.get(APIs.GET_REPORT_CONFIG.interpolate({ reportId: reportId }));

        // let deferred = this.$q.defer();
        // this.$http.get('http://localhost:3000/config/user-report').then(data => {
        //     deferred.resolve(data.data);
        // });
        // return deferred.promise;
    };

    getHistoryConfiguration(sectionName, queryParams) {
        if (!!queryParams) {
            return this.api.get(APIs.GET_HISTORY_CONFIG.interpolate({ sectionName: sectionName }), queryParams);
        } else {
            return this.api.get(APIs.GET_HISTORY_CONFIG.interpolate({ sectionName: sectionName }));
        }
        // let deferred = this.$q.defer();
        // this.$http.get('http://localhost:3000/config/links').then(data => {
        //     deferred.resolve(data.data);
        // });
        // return deferred.promise;
    };

    getCstmAttrForReport(ids, attributes, password) {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_CUSTOM_ATTR_FOR_REPORT, { ids, attributes, password, addCustomAttributesEntities: true }).then((data) => {
            let cstmAttr;
            angular.forEach(data['subjects'], (sub) => {
                cstmAttr = Object.keys(sub.customAttributeEntities).reduce((obj, key) => {
                    obj[key] = sub.customAttributeEntities[key].value;
                    !!sub.customAttributeEntities[key].displayValue && (obj[key + 'Display'] = sub.customAttributeEntities[key].displayValue);
                    return obj;
                }, {});
                sub['customAttributeObj'] = cstmAttr;
            });
            deferred.resolve(data['subjects']);
        });
        return deferred.promise;
    }

    getDynamicAttributes(key) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_DYNAMIC_ATTR, {
            key: key, deleted: false
        }).then(data => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new SelectOption(d.id, d.label))
                })
            }
            deferred.resolve(rtnData);
        }).catch(e => {
            console.log('error while fetching dynamic attributes');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    getData(dataSource, filter, jsonPath, postProcess = null) {
        let deferred = this.$q.defer();
        // if (dataSource == "StudentTeams") {
        let queryParams :{
            aggregate: string,
            jsonPath: string,
            postProcess?: string
        } = {
            aggregate: JSON.stringify(filter),
            jsonPath: jsonPath
        };
        if (postProcess) {
            queryParams.postProcess = JSON.stringify(postProcess)
        }

        this.api.get(APIs.GET_DATA.interpolate({ collection: dataSource }), queryParams).then(data => {
            deferred.resolve(data);
        }).catch(e => {
            console.log('error while fetching dynamic attributes');
            deferred.reject(e);
        });
        return deferred.promise;
    }
    getDynamicAttributesForSubject(subjectId) {
        return this.api.get(APIs.GET_DYNAMIC_ATTR_FOR_SUBJECT.interpolate({
            collectionName: 'StudentTeams',
            id: subjectId
        }));
    };

    getPaginatedReportData(initParams, reportParams) {
        let data = {}
        data["reportName"] = !!initParams.reportName ? initParams.reportName : "";
        data["sectionName"] = !!initParams.sectionName ? initParams.sectionName : "";
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_PAGINATED_REPORT_DATA.interpolate(data), reportParams).then(data => {
            deferred.resolve(data);
        });
        //for testing
        //  this.$http.get('http://localhost:3000/data',queryParams).then(a => {
        //     deferred.resolve(a.data);
        // });
        return deferred.promise;

    }

    getReportDataPost(reportName, reportParams) {
        return this.api.post(APIs.GET_REPORT_DATA, {
            reportName: reportName,
            inputParameters: reportParams
        });
        // let deferred = this.$q.defer();
        // this.$http.get('http://localhost:3000/data').then(data => {
        //     deferred.resolve(data.data);
        // });
        // return deferred.promise;

    }
    getStates(params, idType) {
        let queryParams = {
            key: params || null
        }
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_STATES, queryParams).then(data => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new SelectOption(d[idType], d.name))
                });
            }
            deferred.resolve(rtnData);
        });
        return deferred.promise;
    }

    getStatesFull(params) {
        let queryParams = {
            key: params || null
        }
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_STATES, queryParams).then(data => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push({ "id": d.id, "name": d.name, "address": d.address, "email": d.email })
                });
            }
            deferred.resolve(rtnData);
        });
        return deferred.promise;
    }

    getRLFolders() {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_RL_FOLDERS).then(data => {
            let rtnData = [];
            if (Array.isArray(data)) {
                data.forEach(d => {
                    rtnData.push(new SelectOption(d.id, d.name))
                });
            }
            deferred.resolve(rtnData);
        });
        return deferred.promise;
    }

    getRLFoldersFilter(folderOrgId) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_RL_FOLDERS_FILTER.interpolate({ folderOrgId }))
            .then(data => {
                let rtnData = [];
                if (Array.isArray(data)) {
                    data.forEach(d => {
                        rtnData.push(new DocumentFolder().deserialize(d))
                    });
                }
                deferred.resolve(rtnData);
            });
        return deferred.promise;
    }

    getAttributeData(orgId, attributeName, requestAttributes) {
        let payloadData = {}
        payloadData["orgId"] = !!orgId ? orgId : "";
        payloadData["attributeName"] = !!attributeName ? attributeName : "";
        let queryParams = {
            requestAttributes: requestAttributes
        }
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_ATTRIBUTE_DATA.interpolate(payloadData), queryParams).then(result => {
            let rtnData = [];
            if (Array.isArray(result.listOptions)) {
                result.listOptions.forEach(function (d) {
                    rtnData.push(new eCareVault.SelectOption(d.id, d.label))
                })


            }

            deferred.resolve(rtnData);
        });
        return deferred.promise;
    }
    getHistoryDataPost(reportParams) {
        return this.api.post(APIs.GET_HISTORY_DATA, reportParams);
        // let deferred = this.$q.defer();
        // this.$http.get('http://localhost:3000/data').then(data => {
        //     deferred.resolve(data.data);
        // });
        // return deferred.promise;
    }

    //To Update trial Count for form analytics DTD report
    updateTrialCount(trialCountObj: Object) {
        return this.api.post(APIs.UPDATE_TRIAL_COUNT, trialCountObj);
    }

    //get Form Field Metadata Information
    getFormFieldMetadataInfo(metaObj) {
        return this.api.post(APIs.GET_FORM_FIELD_METADATA, metaObj);
    };

    //create servce note
    createServiceNoteForm(assignmentId: number, note: any) {
        let deferred = this.$q.defer();
        this.api.post(APIs.CREATE_SERVICE_NOTE_FORM.interpolate({ id: assignmentId }), note).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('error while creating service note form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    //update servce note
    updateServiceNoteForm(srvcAsgnId: number, note: any) {
        let deferred = this.$q.defer();
        this.api.put(APIs.UPDATE_SERVICE_NOTE_FORM.interpolate({ id: srvcAsgnId }), note).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('error while updating service note form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    getAssignedOrSubmittedForms(page, size, sort, filter) {
        let deferred = this.$q.defer();
        let body = {
            'page': page || 0,
            'size': size || 10
        }
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }
        if (!!filter) {
            let bodyFilter = {
                "submitted": filter.submitted,
                "subjectId": filter.subjectId,
                "roleFilter": filter.roleFilter
            }
            if (filter.isSubmittedByYou != undefined) {
                bodyFilter['isSubmittedByYou'] = filter.isSubmittedByYou;
            }
            body['filter'] = bodyFilter;
        }

        this.api.post(APIs.GET_ASSIGNED_FORMS, body).then(data => {
            let resp = {};
            let payload = [];
            if (!!data['content']) {
                payload = data['content'];
            }
            resp['totalElements'] = data['totalElements'];
            resp['forms'] = payload;
            deferred.resolve(resp);
        }).catch(e => {
            console.error('System error while fetching forms:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    /*
    *  Assigns a form to or shares a form with one or more users
    *  Arguments
    * - form: Form {
    *       assignmentId: required,
    *       formUsers: [
    *           {
    *               userId: required,
    *               role: required (ACCESS or VIEW, OWN not settable)
    *           }
    *       ]
    *   }
    *
    */
    addUsersToForm(form: any) {
        let deferred = this.$q.defer();
        this.api.put(APIs.ADD_USERS_TO_FORM, form).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('error while adding users to the form');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    handleResponseStatus(rs: any, deferred: any) {
        if (rs.status == 'OK') {
            if (!!rs['errorType'] && rs['errorType'] == 'formError') {
                deferred.reject(rs);
            } else {
                deferred.resolve(rs.payload);
            }
        } else if (rs.status == 'ERROR') {
            console.error('Response Error: ', rs['message']);
            deferred.reject(rs);
        } else if (rs.status == 'WARN') {
            console.error('Response Warning: ', rs['message']);
            if (!!rs['errorType'] && rs['errorType'] == 'formError') {
                deferred.reject(rs);
            } else {
                deferred.resolve(rs.payload);
            }
        }
    }

    getFormTemplate(formId: number) {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_FORM_TEMPLATE.interpolate({ formId })).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('System error while fetching form:', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }

    getAssignedForm(assignmentId: number, password: string, role?: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_ASSIGNED_FORM.interpolate({ assignmentId }), {
            role: role || "ASSIGNOR",
            password: password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('System error while fetching form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    getFormProviders(assignmentId: number, password: string, label?: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_FORM_PROVIDERS.interpolate({ assignmentId }), {
            label: label,
            password: password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('System error while fetching form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    checkAndShareForm(assignmentId: number, subjectId: number, password) {
        let deferred = this.$q.defer();
        this.api.post(APIs.CHECK_AND_SHARE, {
            assignmentId,
            subjectId,
            password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('System error while sharing form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    assignFormToUser(formId: number, subjectId: number, formUsers: any[], dateDue?: any) {
        let deferred = this.$q.defer();
        this.api.put(APIs.ASSIGN_FORM, {
            id: formId,
            subjectId: subjectId,
            formUsers: formUsers,
            dateDue: dateDue || null
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('System error while assigning form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    saveEmbdFormResponses(data: any) {
        let deferred = this.$q.defer();

        this.api.post(APIs.SAVE_EMBEDDED_FORM, {
            "uuid": data.uuid,
            "fields": data.fields
        }, {
            "key": data.key
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('error while saving form response');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    saveFormResponses(data: any, password: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.SAVE_FORM.interpolate({ assignmentId: data.assignmentId }), {
            fields: data.fields,
            password: password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('error while saving form response');
            deferred.reject(e);
        });
        return deferred.promise;
    }

    sendFormAssignedReminder(assignmentId: number) {
        let deferred = this.$q.defer();
        this.api.get(APIs.SAVE_FORM_ASSIGNED_REMINDER.interpolate({ assignmentId })).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('System error while sending remind status:', e);
            deferred.reject({ payload: e });
        });

        return deferred.promise;
    }

    submitAssignedForm(assignmentId: number, password: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.SUBMIT_FORM.interpolate({ assignmentId }), {
            password: password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('error while submiting form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    deleteAssignedForm(assignmentId, password: string) {
        return this.api.post(APIs.DELETE_FORM_ASSIGNMENT.interpolate({ assignmentId }), {
            password: password
        });
    }

    signAssignedForm(assignedFormsId, isSigned, signedBy, password) {
        let deferred = this.$q.defer();
        this.api.post(APIs.SIGN_THE_FORM, {
            "assignedFormsId": assignedFormsId,
            "isSigned": isSigned,
            "signedBy": signedBy,
            "password": password
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('error while signing form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    triggerFormWorkflow(assignmentId, password, subjectId, workflowActionEnumValue, formUsers) {
        let deferred = this.$q.defer();
        this.api.post(APIs.TRIGGER_FORM_WORKFLOW.interpolate({ assignmentId }), {
            "password": password,
            "subjectId": subjectId,
            "formUsers": formUsers
        }, {
            "workflowAction": workflowActionEnumValue
        }).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.error('error while moving form:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    saveFormDynamicAttribute(dAttr: any, metadata: any) {
        let body : {
            "key": string,
            "value": any,
            "parentId": number,
            "subjectId": number,
            "metadata"?: any
        } = {
            "key": dAttr.type,
            "value": dAttr.data,
            "parentId": dAttr.parentId,
            "subjectId": dAttr.subjectId
        };
        if (!!metadata) {
            body.metadata = metadata;
        }
        return this.api.post(APIs.SAVE_DYNAMIC_ATTR_OF_FORM, body);
    }

    updateFormDynamicAttribute(dAttr: any) {
        let body = {
            "key": dAttr.type,
            "subjectId": dAttr.subjectId
        };
        body[dAttr['attr']] = dAttr.data;

        return this.api.patch(APIs.UPDATE_DYNAMIC_ATTR_OF_FORM.interpolate({ id: dAttr.id }), body)
    }

    getAssignedService(crntSubjectId, page = 0, size = 10, sort = null) {
        let deferred = this.$q.defer();
        let additionalParams;
        if (crntSubjectId == null) {
            additionalParams = {};
        } else {
            additionalParams = {
                "subjectId": crntSubjectId
            };
        }
        let body = {
            "page": page || 0,
            "size": size || 10
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }
        this.api.post(APIs.GET_ASSIGNED_SERVICE, body, additionalParams).then(data => {
            let services = [];
            let resp = {};
            if (!!data['content']) {
                let payload = data['content'];
                payload.forEach((p) => {
                    let temp = new Service().deserialize(p);
                    if (!!temp)
                        services.push(temp);
                });
            }
            resp['totalElements'] = data['totalElements'];
            resp['services'] = services;
            deferred.resolve(resp);
        }).catch(e => {
            console.error('System error while fetching assigned services:', e);
            deferred.reject({ payload: e });
        });

        return deferred.promise;
    }

    getPreviousServices(crntSubjectId, crntUserId, page = 0, size = 10, sort = null) {
        let queryParams = {
            "userId": crntUserId
        };
        let body = {
            "page": page || 0,
            "size": size || 10
        };
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.prop,
                "direction": sort.dir
            };
        }

        !!crntSubjectId && (queryParams["subjectId"] = crntSubjectId)

        let deferred = this.$q.defer();
        this.api.post(APIs.GET_CLOSED_SERVICES, body, queryParams).then(data => {
            let services = [];
            let resp = {};
            if (!!data['content']) {
                let payload = data['content'];
                payload.forEach((p) => {
                    let temp = new Service().deserialize(p);
                    if (!!temp)
                        services.push(temp);
                });
            }
            resp['totalElements'] = data['totalElements'];
            resp['services'] = services;
            deferred.resolve(resp);
        },
            e => {
                console.error('System error while fetching previous services:', e);
                deferred.reject({ payload: e });
            }
        );

        return deferred.promise;
    }

    getProviders(userId: number, subjectIdList?: string) {
        let queryParams = {};
        if (!!subjectIdList) {
            queryParams = {
                "subjectIdList": subjectIdList
            };
        }
        return this.api.get(APIs.GET_PROVIDERS.interpolate({ id: userId }), queryParams).then(data => {
            let providers = [];
            if (!!data) {
                for (let i = 0; i < data.length; i++) {
                    let tempProvider = new User().deserialize(data[i]);
                    if (!!tempProvider)
                        providers.push(tempProvider);
                }
            }
            return providers;
        });
    }

    assignService(serviceId: number, assignedUsers: any, assignedSubjects: any, serviceTemplateOptions: any, password: string) {
        return this.api.post(APIs.ASSIGN_SERVICE.interpolate({ serviceId }), {
            assignedUsers: assignedUsers,
            assignedSubjects: assignedSubjects,
            serviceTemplateOptions: serviceTemplateOptions,
            password: password
        });
    }

    shareService(assignedServiceId, sharedUsers) {
        return this.api.post(APIs.SHARE_SERVICE.interpolate({ id: assignedServiceId }), {
            assignedUsers: sharedUsers
        });
    }

    closeAssignedService(assignedServiceId: number, password: String) {
        return this.api.put(APIs.CLOSE_SERVICE.interpolate({ id: assignedServiceId }), {
            status: "COMPLETED",
            password: password
        });
    }

    updateAssignedService(assignedServiceId: number, assignedUsers: any, assignedSubjects: any, serviceTemplateOptions: any, password: string) {
        return this.api.put(APIs.UPDATE_ASSIGNED_SERVICE.interpolate({ id: assignedServiceId }), {
            assignedUsers: assignedUsers,
            assignedSubjects: assignedSubjects,
            serviceTemplateOptions: serviceTemplateOptions,
            password: password
        });
    }

    getAssignedServicefromId(assignedServiceId: number) {
        return this.api.get(APIs.GET_ASSIGNED_SERVICE_FORM_ID.interpolate({ id: assignedServiceId }));
    }

    shareServiceNote(assignedServiceId, noteId, sharedUsers, password) {
        return this.api.post(APIs.SHARE_SERVICE_NOTE.interpolate({
            noteId: noteId,
            id: assignedServiceId
        }), {
            password: password,
            serviceUsers: sharedUsers
        });
    }

    associateTeamsToProject(projectId: number, subjectIds: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.ASSOCIATE_TEAM_PROJECT.interpolate({ projectId }), {
            associateSubjectIds: subjectIds
        }).then(data => {
            let subjects = [];
            if (!!data.associatedSubjects) {
                for (let i = 0; i < data.associatedSubjects.length; i++) {
                    let temp = new Subject().deserialize(data.associatedSubjects[i]);
                    if (!!temp)
                        subjects.push(temp);
                }
            }
            deferred.resolve(subjects);
        }).catch(e => {
            console.error('System error while associating teams to project:', e);
            deferred.reject({ payload: e });
        });
        return deferred.promise;
    }

    reloadTeamMember(teamId: number, teamMemberId: number) {
        return this.api.get(APIs.RELOAD_TEAM_MEMBER.interpolate({
            subjectId: teamId,
            userId: teamMemberId
        }));
    }

    getCoverSheet(subjectId: number) {
        return this.api.post(APIs.GET_COVERSHEET, {
            subjectId: subjectId
        }, null, false);
    }

    getCoverSheetUploads(batchNumber: string) {
        return this.api.get(APIs.GET_COVERSHEET_UPLOADS.interpolate({
            batch: batchNumber
        }), null, false);
    }

    shareCoverSheetLink(batchNumber: string, email: string, personalMsg: string) {
        return this.api.post(APIs.SHARE_COVERSHEET_LINK.interpolate({
            batch: batchNumber
        }), {
            email: email,
            personalMsg: personalMsg
        }, null, false);
    }

    fetchFolders(userId, parentFolderId, queryParamsObj?) {
        let deferred = this.$q.defer();
        this.api.get(APIs.FETCH_FOLDERS.interpolate({
            userId: userId,
            id: parentFolderId
        }), queryParamsObj).then(data => {
            let folders = [];
            let resp = {};
            if (!!data['payload']) {
                let payload = data['payload'];
                payload.forEach((p) => {
                    let temp = new DocumentFolder().deserialize(p);
                    if (!!temp)
                        folders.push(temp);
                });
            }
            resp['totalElements'] = data['totalElements'];
            resp['folders'] = folders;
            deferred.resolve(resp);
        }).catch(e => {
            console.error('Error while fetching document folders:', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }

    deleteDocumentFolder(userId, folderId) {
        return this.api.delete(APIs.DELETE_DOCUMENT_FOLDER.interpolate({
            userId: userId,
            id: folderId
        }), {
            userId: userId,
            id: folderId
        });
    }

    checkEmlExists(email: string) {
        let deferred = this.$q.defer();
        this.api.post(APIs.CHECK_EMAIL_EXISTS, {
            providerIdentity: email
        }).then(data => {
            if (!!data) {
                deferred.resolve(new User().deserialize(data));
            } else {
                deferred.reject();
            }
        });
        return deferred.promise;
    }

    getWSUrl() {
        return this.api.get(APIs.GET_WS_URL, null, false);
    }

    getSASSToken() {
        return this.api.get(APIs.GET_SAS_TOKEN, {}, false).then(data => {
            return data;
        });
    }

    getUserIntegrations() {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_USER_INTEGRATIONS).then((data) => {
            let userIntegrations = new UserIntegrations().deserialize(data);
            deferred.resolve(userIntegrations);
        }).catch(e => {
            console.error('Error while getUserIntegrations', e);
            deferred.reject(e);
        })
        return deferred.promise;
    }

    saveZoomIntegration(code) {
        let deferred = this.$q.defer();
        let body = {
            code: code
        }
        this.api.post(APIs.SAVE_ZOOM_INTEGRATION, body).then(() => {
            deferred.resolve(true);
        }).catch(e => {
            console.error('Error while saving zoom integration', e);
            deferred.reject(e);
        })
        return deferred.promise;
    }

    saveCalendarIntegration(body) {
        let deferred = this.$q.defer();
        this.api.post(APIs.SAVE_CALENDAR_INTEGRATION, body).then((data) => {
            deferred.resolve(true);
        }).catch(e => {
            console.error('Error while saving calendar integration', e);
            deferred.reject(e);
        })
        return deferred.promise;
    }

    getActiveOrgUsers(orgName, page = 0, size = 10, serchText = "") {
        let deferred = this.$q.defer();
        this.api.post(APIs.GET_ACTIVE_ORG_USERS, { page, size, "filter": { "fullName": serchText } }).then(data => {
            deferred.resolve(data);
        });
        return deferred.promise;
    }
    createClientProfile(subjectId: string | number) {
        let deferred = this.$q.defer();
        this.api.post(APIs.CREATE_CLIENT_ACCOUNT.interpolate({ subjectId })).then((data) => {
            deferred.resolve(data);
        }).catch(e => {
            console.error('Error while fetching document folders:', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }
    resetClientPassword(subjectId: string | number) {

        let deferred = this.$q.defer();
        this.api.post(APIs.RESET_CLIENT_PASSWORD.interpolate({ subjectId })).then((data) => {
            deferred.resolve(data);
        }).catch(e => {
            console.error('Error while fetching document folders:', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }
    checkMembership(userId: string | number) {
        let deferred = this.$q.defer();
        this.api.get(APIs.CHECK_USER_MEMBERSHIP.interpolate({ userId })).then((data) => {
            deferred.resolve(data);
        }).catch(e => {
            console.error('Error while checking user membership', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }
    //download Report csv with report params
    downloadReportCSV(reportParamas) {
        let deferred = this.$q.defer();
        this.api.post(APIs.DOWNLOAD_REPORT_CSV, reportParamas).then(data => {
            deferred.resolve(data);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    viewLink(linkParams: any) {
        let body = JSON.parse(JSON.stringify(linkParams));
        return this.api.post(APIs.LINK_EVENT_REPORT, body);
    }

    checkMonetizedLink(videoUrl: any) {
        let deferred = this.$q.defer();
        let body = JSON.parse(JSON.stringify(videoUrl));
        this.api.post(APIs.CHECK_LINK_MONETIZED, body).then(data => {
            deferred.resolve(data.isVideoMonetized);
        }).catch(e => deferred.reject(e));
        return deferred.promise;
    }

    getYtVideoDetails(videoId: string) {
        return this.api.post(APIs.GET_YT_DETAILS.interpolate({ videoId }));
    }

    getUserExperience() {
        let deferred = this.$q.defer();
        this.api.get(APIs.GET_USER_EXPERIENCE).then((data) => {
            let userExperience = new UserExperience().deserialize(data);
            deferred.resolve(userExperience);
        }).catch(e => {
            console.error('Error while getUserExperience', e);
            deferred.reject(e);
        })

        /// For local testing of userExperience ///
        // this.$http.get('http://localhost:3000/get/user-experience').then(s => {
        //
        //         deferred.resolve(s.data);
        // })
        /////////////////////////////////////////
        return deferred.promise;
    }

    fetchItems(pageNo = 0, size = 10, sort = null, filter = null) {
        let body = {
            "page": pageNo,
            "size": size
        }
        if (!!sort) {
            body['sortOn'] = {
                "properties": sort.properties,
                "direction": sort.direction
            };
        }
        if (!!filter) {
            body['filter'] = filter;
        }
        return this.api.post(APIs.GET_CARE_ITEMS, body).then(data => {
            return data;
        });
    }

    saveCareItemInteractions(data) {
        return this.api.post(APIs.CARE_ITEM_INTERACTIONS, data);
    }

    fetchAISummary(documentId) {
        return this.api.get(APIs.GET_AI_SUMMARY, { documentId });
    }

    regenerateAISummary(documentId) {
        return this.api.post(APIs.REGENERATE_AI_SUMMARY, { documentId });
    }

    confirmRegenerateAISummary(id, documentId, status) {
        return this.api.patch(APIs.CONFIRM_REGENERATE_AI_SUMMARY, { id, documentId, status });
    }

    fetchInvitationCounts() {
        return this.api.get(APIs.GET_INVITATION_COUNTS);
    }

    sendBulkInvitations(invitationType: string, password: string) {
        return this.api.post(APIs.SEND_BULK_INVITATION.interpolate({ invitationType }),
            {
                password: password
            });
    }

    requestInvitationsInBulk() {
        return this.api.post(APIs.REQUEST_INVITATIONS_IN_BULK);
    }

    acceptBulkInvitations() {
        return this.api.put(APIs.ACCEPT_BULK_INVITATIONS);
    }

    processBotRequest(body) {
        return this.api.post(APIs.PROCESS_BOT_REQUEST, body);
    }

    assignCreateProjectTeamForm(body) {
        let deferred = this.$q.defer();
        this.api.post(APIs.ASSIGN_CREATE_PROJECT_TEAM_FORM, body).then(data => {
            this.handleResponseStatus(data, deferred);
        }).catch(e => {
            console.log('System error while fetching form:', e);
            deferred.reject(e);
        });
        return deferred.promise;
    }

    /**
     * Get messages for login screen (Org + System)
     */
    getMessages() {
        let deferred = this.$q.defer();
         this.api.get(APIs.GET_SYSTEM_MESSAGES)
            .then(response => deferred.resolve(response))
            .catch(error => {
                console.error('Failed to get messages:', error);
                deferred.reject(error);
            });
        return deferred.promise;
    }

    /**
     * Update message dismiss checkbox date
     */
    updateMessageDismiss(): angular.IPromise<void> {
        let deferred = this.$q.defer();
        return this.api.post(APIs.DISMISS_SYSTEM_MESSAGE)
            .then((s) => deferred.resolve(s))
            .catch(error => {
                console.error('Failed to update dismiss date:', error);
                deferred.reject(error); });
                return deferred.promise;
    }

    /**
     * Create or update system message
     * @param messageData - { organizationId: number, messageType: string, message: string }
     * @returns Promise with created/updated message
     */
    createSystemMessage(messageData: { organizationId: number; messageType: string; message: string }): angular.IPromise<any> {
        let deferred = this.$q.defer();
        let body = {
            organizationId: messageData.organizationId,
            messageType: messageData.messageType,
            message: messageData.message
        };

        this.api.post(APIs.CREATE_SYSTEM_MESSAGE, body)
            .then((response) => {
                deferred.resolve(response);
            })
            .catch(error => {
                console.error('Failed to create system message:', error);
                deferred.reject(error);
            });

        return deferred.promise;
    }

    /**
     * Deactivate system message
     * @param messageType - Type of message to deactivate
     * @param organizationId - Organization ID
     * @returns Promise
     */
    deactivateSystemMessage(messageType: string, organizationId: number): angular.IPromise<any> {
        let deferred = this.$q.defer();
        let url = `${APIs.DEACTIVATE_SYSTEM_MESSAGE}?messageType=${messageType}&organizationId=${organizationId}`;

        this.api.post(url, {})
            .then((response) => {
                deferred.resolve(response);
            })
            .catch(error => {
                console.error('Failed to deactivate system message:', error);
                deferred.reject(error);
            });

        return deferred.promise;
    }

    /**
     * Get document signature status
     * @param documentId - ID of the document
     * @returns Promise with signature status data
     */
    getDocumentSignatureStatus(documentId: number): angular.IPromise<any> {
       return  this.api.get(APIs.GET_DOCUMENT_SIGNATURE_STATUS.interpolate({ documentId }));
    }
}

angular.module('eCareVault.common.JavaApiAdapterService').service('JavaApiAdapterService', JavaApiAdapterService);
